<template lang="html">
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">#</th>
        <th scope="col" class="border-0">E-mail</th>
        <th scope="col" class="border-0 text-center">Produtos</th>
        <th scope="col" class="border-0 text-center">Primeiro acesso</th>
        <th scope="col" class="border-0 text-center">Último acesso</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in users" :key="index">
        <td>{{ index }}</td>
        <td class="td-4">{{ row.email }}</td>
        <td class="text-center link">
          <d-link @click.native="openDetails(row)">{{ row.n_views }}</d-link>
        </td>
        <td class="text-center">{{ new Date(row.created_at).toLocaleString('pt-BR') }}</td>
        <td class="text-center">{{ new Date(row.updated_at).toLocaleString('pt-BR') }}</td>
      </tr>
      <tr v-if="users.length === 0">
        <td colspan="5" class="no-content">Ainda não tem nenhum e-mail de usuario registrado.</td>
      </tr>
    </tbody>
    <view-details-modal :headers="headers" :body="body" />
  </table>
</template>

<script>
import { mapActions } from 'vuex';
import ViewDetailsModal from './ViewDetailsModal.vue';

export default {
  name: 'report-product-table',
  components: {
    ViewDetailsModal,
  },
  props: {
    users: {
      type: Array,
    },
  },
  data() {
    return {
      headers: [
        { label: 'Data' },
        { label: 'Slug' },
      ],
      body: [],
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
    ]),
    openDetails(row) {
      this.body = row.product;
      this.setToggle({ type: 'view_details_modal', bool: true });
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.td {
  &-1 {
    min-width: 100px;
  }
  &-2 {
    min-width: 120px;
  }
  &-3 {
    min-width: 170px;
  }
  &-4 {
    min-width: 300px;
  }
}
</style>
